/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
import { Fragment } from '@wordpress/element';
import { Toolbar, Button } from '@wordpress/components';
import { addFilter } from '@wordpress/hooks';

/**
 * Inner dependencies.
 */
import blockInfo from '../constants';
const { hookPrefix } = blockInfo;

addFilter( `gutenify-block-${ hookPrefix }-block-controls`,
	`Gutenify/Block/${ hookPrefix }/InspectorControls/BlockControls/edit-slides`, ( content, props ) => {
		const { attributes, setAttributes, isSelected } = props;
		const { location, pinned } = attributes;
		return [ ...content, <Fragment key="gutenify-block-map-block-controls-default">
			{ isSelected && <>
				{ '' !== location && <Toolbar>
					<Button isPressed={ ! pinned } icon="edit" showTooltip={ true } label={ __( 'Edit' ) } className={ 'components-toolbar-button' } onClick={ () => {
						setAttributes( {
							pinned: ! pinned,
						} );
					} } />
				</Toolbar> }
			</> }
		</Fragment> ];
	} );
